import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetAuftraegeMutation } from '../../api/AgSachbearbeiterAPI';
import { useGetAuftragTableOrderServiceMutation, useSetAuftragTableOrderServiceMutation } from '../../api/ProfileAPI';
import AuftragCustomerDetailComponent from '../../component/AuftragCustomerDetailComponent/AuftragCustomerDetailComponent';
import ScrollToTopBadge from '../../component/ScrollToTop';
import { IAgSbAuftragTableOrderColumns } from '../../types/Types';
import { formatToEuroDate } from '../../util/DateUtils';
import PaginatorComponent from '../eigeneauftraege/component/PaginatorComponent';
import { PaginatorDto } from '../eigeneauftraege/EigeneAuftraegeListe';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from "./agsachbearbeiter.module.scss";


/**
 * @author noone
 */
export default function AgSbAuftragsListe() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [getProfileParameter] = useGetAuftragTableOrderServiceMutation();
  const [setProfileParameter] = useSetAuftragTableOrderServiceMutation();
  const [getAuftraege] = useGetAuftraegeMutation();

  const parameterName = "agsbauftragsliste";

  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [search, setSearch] = useState<string>("");
  const [sortBy, setSortBy] = useState<string>("");
  const [sortDirection, setSortDirection] = useState<string>("");

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [liste, setListe] = useState<PaginatorDto>({ offset: 0, limit: 10, totalCount: 0, data: [] });

  const [uid, setUid] = useState<string>();


  const sort = (column: string) => {

    if (sortBy !== column) {
      setSortDirection("asc");
    } else if (sortDirection === "") {
      setSortDirection("asc");
    } else if (sortDirection === "asc") {
      setSortDirection("desc");
    } else if (sortDirection === "desc") {
      setSortDirection("");
    }

    setSortBy(column);
  }

  const lade = () => {
    setLoaded(false);
    getAuftraege({
      offset: offset,
      limit: limit,
      search: search,
      sortBy: sortBy,
      sortDirection: sortDirection
    }).unwrap()
      .then(data => setListe(data))
      .catch((e) => console.log(e))
      .finally(() => setLoaded(true));
  }

  const getIconBySort = (column: string) => {
    if (column !== sortBy) {
      return "bi bi-arrow-down-up";
    } else if (sortDirection === "asc") {
      return "bi bi-arrow-up";
    } else if (sortDirection === "desc") {
      return "bi bi-arrow-down";
    } return "bi bi-arrow-down-up";
  }

  const suche = (e: React.FormEvent) => {
    e.preventDefault();
    setOffset(0);
    lade();
  }

  const getFarbeZuStatus = (status: string) => {
    if (status === "NEU") {
      return "lightblue";
    } else if (status === "IN_TERMINIERUNG") {
      return "lightblue";
    } else if (status === "IN_TERMINIERUNG") {
      return "yellow";
    } else if (status === "FERTIG") {
      return "lightgreen";
    } else
      return "white";
  }

  const onSpeichern = () => {
    setUid(undefined);
    window.scrollTo(0, 0);
  }
  
  const pageChangeHandler = (page: number) => {
    setOffset(page * limit - limit);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [getAuftraege]);

  useEffect(() => {
    getProfileParameter(parameterName).unwrap().then((dto) => {
      var intDirection: number = 0;
      let columnToSort = "";

      if (dto.art !== 0) {
        columnToSort = "art";
        intDirection = dto.art;
      }
      if (dto.status !== 0) {
        columnToSort = "status";
        intDirection = dto.status;
      }
      if (dto.auftragnr !== 0) {
        columnToSort = "auftragnr";
        intDirection = dto.auftragnr;
      }
      if (dto.name !== 0) {
        columnToSort = "name";
        intDirection = dto.name;
      }
      if (dto.lieferort !== 0) {
        columnToSort = "lieferort";
        intDirection = dto.lieferort;
      }
      if (dto.termin !== 0) {
        columnToSort = "termin";
        intDirection = dto.termin;
      }
      if (dto.bearbeiter !== 0) {
        columnToSort = "bearbeiter";
        intDirection = dto.bearbeiter;
      }
      if (dto.erstellt_am !== 0) {
        columnToSort = "erstellt_am";
        intDirection = dto.erstellt_am;
      }

      setSortBy(columnToSort);
      if (intDirection === 1) {
        setSortDirection("asc");
      } else if (intDirection === -1) {
        setSortDirection("desc");
      }
    }).catch((error) => {
      console.log(error);
      setSortBy("");
      setSortDirection("");
    });
  }, []);

  // Load data when sort or offset changes
  useEffect(() => {
    // window.scrollTo(0, 0);
    lade();
  }, [sortBy, sortDirection, offset]);

  return (
    <>
      <ScrollToTopBadge />

      <LandingpageHeader />

      <div style={{ marginLeft: "3em", marginRight: "3em" }} >

        {!uid &&
          <>
            <div>

              <button
                onClick={() => {
                  navigate({
                    pathname: "/",
                    search: ""
                  });
                }}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragMain.backButton')}
              </button>

            </div>

            <h3>{t('deTranslation.auftragMain.titel')}</h3>

            <form onSubmit={suche}>
              <label>Suche:</label>
              <div>
                <input type="text" className='form-control' placeholder='Suche' value={search} onChange={(e) => setSearch(e.target.value)} />
                <button type="submit" className="btn btn-primary">Suche</button>
              </div>
            </form>

            {liste?.totalCount === 0 && <div>Keine Aufträge vorhanden</div>}

            {liste?.data?.length !== 0 && <p>
              Anzahl {liste.totalCount}
            </p>}

            <PaginatorComponent offset={offset} limit={limit} totalCount={liste.totalCount} pageChange={pageChangeHandler} />

            <table className="table table-striped">
              <thead>
                <tr>
                  <th onClick={() => { sort("art") }}>Art <i style={{ marginLeft: "10px" }} className={getIconBySort("art")} /></th>
                  <th onClick={() => { sort("status") }}>Status <i style={{ marginLeft: "10px" }} className={getIconBySort("status")} /></th>
                  <th onClick={() => { sort("auftragnr") }}>Auftragsnr. <i style={{ marginLeft: "10px" }} className={getIconBySort("auftragnr")} /></th>
                  <th onClick={() => { sort("name") }}>Name <i style={{ marginLeft: "10px" }} className={getIconBySort("name")} /></th>
                  <th onClick={() => { sort("lieferort") }}>Lieferort <i style={{ marginLeft: "10px" }} className={getIconBySort("lieferort")} /></th>
                  <th onClick={() => { sort("termin") }}>Termin <i style={{ marginLeft: "10px" }} className={getIconBySort("termin")} /></th>
                  <th onClick={() => { sort("bearbeiter") }}>Bearbeiter <i style={{ marginLeft: "10px" }} className={getIconBySort("bearbeiter")} /></th>
                  <th onClick={() => { sort("erstellt_am") }}>Erstellt am <i style={{ marginLeft: "10px" }} className={getIconBySort("erstellt_am")} /></th>
                  <th>Option</th>
                </tr>
              </thead>
              <tbody>
                {
                  liste?.data?.map((e, index) => (
                    <tr key={e.uid} >
                      <td style={{ padding: "12px 16px" }}>{e.art}</td>
                      <td style={{ padding: "12px 16px" }}><label style={{ borderRadius: "10px", border: "none", padding: "10px", backgroundColor: getFarbeZuStatus(e.status) }}>{e.status}</label></td>
                      <td style={{ padding: "12px 16px" }}>{e.auftragsnr_ag}</td>
                      <td style={{ padding: "12px 16px" }}>{e.vorname_endkunde} {e.name_endkunde}</td>
                      <td style={{ padding: "12px 16px" }}>{e.stadt_lieferadresse}</td>
                      <td style={{ padding: "12px 16px" }}>{formatToEuroDate(e.aktuellerTermin)}</td>
                      <td style={{ padding: "12px 16px" }}>{e.bearbeiterName}</td>
                      <td style={{ padding: "12px 16px" }}>{formatToEuroDate(e.createDate)}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <button onClick={() => setUid(e.uid)} className={styles.wga} ><i className="bi bi-pencil"></i></button>
                      </td>
                    </tr>
                  ))
                }
              </tbody >

            </table>

            <PaginatorComponent offset={offset} limit={limit} totalCount={liste.totalCount} pageChange={pageChangeHandler} />

          </>
        }

        {
          uid &&
          <>
            <div>

              <button
                onClick={() => setUid(undefined)}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
              </button>

            </div>

            <h3>{t('deTranslation.auftragDetails.titel')}</h3>
            <AuftragCustomerDetailComponent uid={uid} onSpeichern={onSpeichern} />
          </>
        }

        <Footer />
      </div >
    </>
  );

}


